<template lang="pug">
  b-modal(
    v-model="value_"
    title="Syncing Availability"
    modal-class="channex-sync-availability"
    centered
    hide-footer
    no-close-on-esc
  )
    .syncing-modal__content
      b-form
        info-row.info-main-row.syncing-unit-ids.py-2(title="Unit(s)" :sizing="3")
          vue-multiselect(
            v-model="form.unit_ids"
            :options="unitItems"
            :multiple="true"
            :hide-selected="true"
            :allow-empty="false"
            :disabled="!!form.id"
            :searchable="false"
            label="name"
            track-by="id"
            @select="onSelectUnit"
          )

        info-row.info-main-row.py-2(title="Date From" :sizing="3")
          b-input-group.syncing-date(@click.stop="showDateFrom = !showDateFrom")
            b-form-input(
              :value="formattedDateFrom"
              :state="fieldState.date_from"
            )
            b-input-group-append(is-text)
              i.fi.fi-calendar(@click.stop="showDateFrom = !showDateFrom")

          .date-picker--from
            v-date-picker.syncing-date-picker.inline(
              v-if="showDateFrom"
              :value="form.date_from"
              :attributes="attrs"
              :disabled-dates="disabledDates"
              :disabled-attribute="disabledAttributes"
              :show-day-popover="false"
              mode="single"
              is-inline
              show-caps
              @input="onSelectDateFrom"
            )

        info-row.info-main-row.py-2(title="Date To" :sizing="3")
          b-input-group.syncing-date(@click.stop="showDateTo = !showDateTo")
            b-form-input(
              :value="formattedDateTo"
              :state="fieldState.date_to"
            )
            b-input-group-append(is-text)
              i.fi.fi-calendar(@click.stop="showDateTo = !showDateTo")

          .date-picker--to
            v-date-picker.syncing-date-picker.inline(
              v-if="showDateTo"
              :value="form.date_to"
              :attributes="attrs"
              :disabled-dates="disabledDates"
              :disabled-attribute="disabledAttributes"
              :show-day-popover="false"
              mode="single"
              is-inline
              show-caps
              @input="onSelectDateTo"
            )

      hr
      b-row.mt-2
        b-col.text-right.px-2(xs="12")
          b-button(
            variant="secondary"
            @click="onSyncAvailability"
          ) Send

</template>

<script>
import { mapGetters } from 'vuex';
import { formatDate } from '@/utils/date-helper';

export default {
  name: 'SyncAvailabilityModal',

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  components:{
    InfoRow: () => import('@/components/InfoRow'),
  },

  data: () => ({
    attrs: [
      {
        key: 'today',
        highlight: {
          borderColor: '#28a745',
          borderWidth: '2px',
          borderStyle: 'solid',
        },
        dates: new Date()
      }
    ],

    disabledAttributes: {
      contentStyle: {
        color: '#d3d3d3',
        cursor: 'not-allowed',
        fontWeight: '400',
      }
    },

    form: {
      unit_ids: [],
      date_from: null,
      date_to: null
    },

    checkingForm: false,
    showDateFrom: false,
    showDateTo: false,
  }),

  computed: {
    ...mapGetters([
      'getUnits',
    ]),

    value_: {
      get () {
        return this.value;
      },

      set (v) {
        this.$emit('input', v);
      }
    },

    disabledDates() {
      const last_date = this.$moment().subtract(1, 'day');

      return {
        start: null,
        end: last_date
      }
    },

    fieldState () {
      return {
        date_from: this.checkingForm
          ? !!this.form.date_from
          : null,
        date_to: this.checkingForm
          ? !!this.form.date_to
          : null,
      }
    },

    formattedDateFrom() {
      return this.form.date_from
        ? formatDate(this.form.date_from, 'MMMM DD, YYYY')
        : '';
    },

    formattedDateTo() {
      return this.form.date_to
        ? formatDate(this.form.date_to, 'MMMM DD, YYYY')
        : '';
    },

    unitItems() {
      const units = this.getUnits
        .map(unit => ({
          id: unit.id,
          name: unit.unit_name
        }));

      units.unshift({
        id: -1,
        name: 'All'
      });

      return units;
    }
  },

  mounted () {
    // window.addEventListener('click', () => {
    //   this.showDateFrom = this.showDateTo = false;
    // });
  },

  methods: {
    onClose() {
      this.$emit('input', false);
    },

    onSelectUnit (v) {
      this.$nextTick(() => {
        if (v && v.id > 0) {
          this.form.unit_ids = this.form.unit_ids.filter(u => u.id !== -1);
        } else if (!v || v.id === -1) {
          this.form.unit_ids = [
            this.unitItems[0]
          ];
        }

        this.form = {
          ...this.form
        };
      })
    },

    onSelectDateFrom (v) {
      this.showDateFrom = false;
      this.form.date_from = v;
    },

    onSelectDateTo (v) {
      this.showDateTo = false;
      this.form.date_to = v;
    },

    onSyncAvailability() {
      this.checkingForm = true;

      if (
        this.fieldState.date_from === false ||
        this.fieldState.date_to === false
      ) {
        return;
      }

      this.$emit('sync', {
        unit_ids: this.form.unit_ids.map(u => u.id),
        date_from: this.$moment(this.form.date_from).format('YYYY-MM-DD'),
        date_to: this.$moment(this.form.date_to).format('YYYY-MM-DD'),
      });
    }
  },

  watch: {
    value () {
      this.showDateFrom = this.showDateTo = false;
      this.form.unit_ids = [ this.unitItems[0] ];
      this.form.date_from = null;
      this.form.date_to = null;
    }
  }
};
</script>

<style lang="scss">
.channex-sync-availability {
  .modal-dialog {
    width: 550px;
  }

  .syncing-modal__content {
    padding: 10px;
  }

  .syncing-unit-ids {
    .multiselect__tags {
      border: 1px solid #ced4da;
      min-height: 20px;
      line-height: 1;
    }
  }

  .syncing-date {
    input {
      max-width: 360px;
      pointer-events: none;
    }

    .input-group-text {
      padding: 4px 6px;
    }

    .fi-calendar {
      cursor: pointer;
      font-size: 26px;
      line-height: 1;
    }
  }

  .syncing-date-picker {
    &.inline {
      bottom: 48px;
      position: absolute;
      z-index: 2;

      &:before {
        content: "";
        border: 8px solid #dadada;
        border-left-color: transparent;
        border-right-color: transparent;
        position: absolute;
        border-bottom-color: transparent;
        right: 120px;
        bottom: -16px;
        z-index: 1;
      }

      &:after {
        content: "";
        border: 8px solid rgb(250, 250, 250);
        border-left-color: transparent;
        border-right-color: transparent;
        position: absolute;
        border-bottom-color: transparent;
        right: 120px;
        bottom: -15px;
        z-index: 2;
      }
    }

    input {
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      font-weight: 400;
      line-height: 1.8;
      max-width: 100%;
      padding: 4px 12px;
      pointer-events: none;
      width: 100%;
    }

    &.error {
      input {
        border-color: #dc3545 !important;
      }
    }
  }
}
</style>
